module.exports = __webpack_public_path__ + "static/img/bg.fa1bc207.png";